"use strict";

import onInitModulesInsScope from "../onInitModulesInScope";

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        $scope.find('.js-image-radio').each(function () {
            let $baseElement = $(this),
                $inputs = $baseElement.find('.js-image-radio__input'),
                $clearBtn = $baseElement.find('.js-image-radio__clear-btn'),
                $groups = $baseElement.find('.js-image-radio__group');

            $groups.each(function () {
                let $group = $(this),
                    $input = $group.find('.js-image-radio__input'),
                    $image = $group.find('.js-image-radio__img'),
                    $imageUpload = $group.find('.js-image-radio__upload-input'),
                    $imageEmpty = $group.find('.js-image-radio__upload-empty'),
                    $imageEmptyCheckbox = $group.find('.js-image-radio__upload-empty-checkbox'),
                    $label = $image.closest('label');
                console.log('test', $imageEmptyCheckbox);

                $input.each(function () {
                    if ($(this).is(':checked')) {
                        $clearBtn.removeClass('hidden');
                    }
                });

                $input.on('change', function () {
                    if ($(this).is(':checked')) {
                        $clearBtn.removeClass('hidden');
                    }
                });

                $clearBtn.on('click', function () {
                    $inputs.prop('checked', false);
                    $clearBtn.addClass('hidden');
                });

                $imageUpload.on('change', function () {
                    readURL(this, $image);
                    if ($input.prop('disabled')) {
                        $input.prop('disabled', false);
                    }
                    $input.prop('checked', true);
                    $input.trigger('change');
                    if ($label.hasClass('pe-none')) {
                        $label.removeClass('pe-none');
                    }
                });

                $imageEmpty.on('click', function () {
                    $imageUpload.val('');
                    $image.attr('src', '').prop('hidden', true);
                    $imageEmptyCheckbox.prop('checked', true);
                    $input.prop('checked', false);
                    $input.trigger('change');
                    $input.prop('disabled', true);
                    $label.addClass('pe-none');
                });
            })
        });
    })
}


function readURL(input, $image) {
        console.log('readURL');
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
            console.log($image);
            console.log('src', e.target.result);
            $image.attr('src', e.target.result).prop('hidden', false);
        };

        reader.readAsDataURL(input.files[0]);
    }
}